export enum YesNoConsidering {
	No = 0,
	Yes = 10,
	Considering = 20,
}
